'use client'

import { Monitor, Moon, Sun } from 'lucide-react'
import Segmented, { type SegItem } from '@/components/room/chrome/Segmented'
import { setThemePreference, useThemePreference } from '@/lib/theme/preference'
import type { ThemePreference } from '@/lib/theme/boot'

/**
 * System / Light / Dark.
 *
 * A SELECTION, so it is the Segmented primitive (AGENTS.md "Button +
 * selection rule") — never a sun/moon button that flips on click. A flip
 * button has two states and this preference has three: it could take you to
 * light or dark but never back to "follow my OS", which is the default and
 * the setting most people should end up on.
 *
 * `guided-theme` scopes the `--ed-*` tokens Segmented paints in; this switch
 * mounts in places that are not otherwise inside the editor (the body-portalled
 * account menu, the marketing footer).
 */
const ITEMS: readonly SegItem[] = [
  { value: 'system', label: 'System', icon: Monitor },
  { value: 'light', label: 'Light', icon: Sun },
  { value: 'dark', label: 'Dark', icon: Moon },
]

export default function ThemeSwitch({
  iconOnly = false,
  testId = 'theme-switch',
}: {
  /** Icons with the names kept for assistive tech — for a tight row. */
  iconOnly?: boolean
  testId?: string
}) {
  const pref = useThemePreference()
  return (
    <div className="guided-theme">
      <Segmented
        items={ITEMS}
        value={pref}
        onChange={(v) => setThemePreference(v as ThemePreference)}
        iconOnly={iconOnly}
        testId={testId}
      />
    </div>
  )
}
